module.exports = "/_next/static/images/plane-monotone-f2536da970e1f6f95fd344ad6fd6935c.svg";